import {fetchDelete, fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const deleteUser = (
    userId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchDelete(
        uri + "/user/" + userId,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findUserVirtualTipz = (
    userId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/" + userId + "/virtualtipz",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findUserBuyPurchaseHistory = (
    userId,
    year,
    month,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/" + userId + "/purchase/history/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findUserTipHistory = (
    venueId,
    year,
    month,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/tip/history/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findUserDanceHistory = (
    venueId,
    year,
    month,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/dance/history/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findUserDrinkHistory = (
    venueId,
    year,
    month,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/drink/history/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const getUserVenueMonths = (
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/dates",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};